module.exports = __webpack_public_path__ + "img/shentianlan.01f58f6b.png";